/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AccountCredentials { 
    /**
     * Access Key ID
     */
    access_key_id: string;
    /**
     * Secret Access Key
     */
    secret_access_key: string;
    /**
     * Session Token
     */
    session_token?: string;
}

